/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Termsagreed_Allocationamount3Inputs */

const en_coinvestments_termsagreed_allocationamount3 = /** @type {(inputs: Coinvestments_Termsagreed_Allocationamount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation Amount`)
};

/**
* | output |
* | --- |
* | "Allocation Amount" |
*
* @param {Coinvestments_Termsagreed_Allocationamount3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_termsagreed_allocationamount3 = /** @type {((inputs?: Coinvestments_Termsagreed_Allocationamount3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Termsagreed_Allocationamount3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_termsagreed_allocationamount3(inputs)
});
export { coinvestments_termsagreed_allocationamount3 as "coInvestments_termsAgreed_allocationAmount" }